/* ==========================================================================
   Natuliv header behaviour
   - Glass state: `.nv-glass` on #header-component once scrollY > 120px
     (templates without a full-bleed hero start in glass).
   - Mega menu: the "Productos" nav link (no children) opens the
     `nv-mega-menu` section placed right after the header in header-group.
   ========================================================================== */
(function () {
  'use strict';

  var GLASS_AT = 120;

  function header() {
    return document.getElementById('header-component');
  }

  /* ---------------- glass ---------------- */
  /* Horizon scrolls the window on most viewports but `.page-wrapper` on some; read both. */
  function scrollTop() {
    var pw = document.querySelector('.page-wrapper');
    var a = window.scrollY || document.documentElement.scrollTop || 0;
    var b = pw ? pw.scrollTop || 0 : 0;
    return Math.max(a, b);
  }

  function updateGlass() {
    var h = header();
    if (!h) return;
    var transparent = h.hasAttribute('transparent');
    var y = scrollTop();
    // Glass depends on scroll only. The mega menu paints its own warm underlay on top of it
    // (see nv-theme.css [data-nv-mega-open]); dropping glass here would change the header
    // padding and make the bar jump while hovering the trigger.
    var glass = !transparent || y > GLASS_AT;
    h.classList.toggle('nv-glass', glass);
  }

  /* ---------------- mega menu ---------------- */
  var closeTimer = null;

  function panel() {
    return document.querySelector('[data-nv-mega-panel]');
  }

  function trigger() {
    var h = header();
    if (!h) return null;
    return h.querySelector('.menu-list__link[data-nv-mega-trigger]');
  }

  function openMega() {
    var p = panel();
    var h = header();
    if (!p || !h) return;
    clearTimeout(closeTimer);
    var rect = h.getBoundingClientRect();
    p.style.setProperty('--nv-mega-top', Math.round(rect.bottom) + 'px');
    p.removeAttribute('hidden');
    requestAnimationFrame(function () {
      p.setAttribute('data-open', '');
    });
    h.setAttribute('data-nv-mega-open', '');
    var t = trigger();
    if (t) t.setAttribute('aria-expanded', 'true');
    updateGlass();
  }

  function closeMega(immediate) {
    var p = panel();
    var h = header();
    if (!p || !h) return;
    p.removeAttribute('data-open');
    h.removeAttribute('data-nv-mega-open');
    var t = trigger();
    if (t) t.setAttribute('aria-expanded', 'false');
    var hide = function () {
      p.setAttribute('hidden', '');
    };
    if (immediate) hide();
    else setTimeout(hide, 220);
    updateGlass();
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      closeMega(false);
    }, 160);
  }

  function markTrigger() {
    var h = header();
    var p = panel();
    if (!h || !p) return;
    var label = (p.getAttribute('data-nv-mega-trigger-label') || 'Productos').trim().toLowerCase();
    // exact label first, then common catalog labels, so the panel still opens before the menu is renamed
    var candidates = [label, 'productos', 'products', 'catálogo', 'catalogo', 'catalog', 'tienda', 'shop'];
    var links = h.querySelectorAll('.menu-list__link');
    var match = null;
    for (var c = 0; c < candidates.length && !match; c++) {
      for (var i = 0; i < links.length; i++) {
        var title = links[i].querySelector('.menu-list__link-title');
        var text = (title ? title.textContent : links[i].textContent).trim().toLowerCase();
        if (text === candidates[c]) { match = links[i]; break; }
      }
    }
    for (var k = 0; k < links.length; k++) {
      if (links[k] === match) {
        var i = k;
        links[i].setAttribute('data-nv-mega-trigger', '');
        links[i].setAttribute('aria-haspopup', 'true');
        links[i].setAttribute('aria-expanded', 'false');
        links[i].setAttribute('aria-controls', p.id);
        return links[i];
      }
    }
    return null;
  }

  function wireMega() {
    var t = markTrigger();
    var p = panel();
    var h = header();
    if (!t || !p || !h) return;

    var mq = window.matchMedia('(min-width: 990px)');
    function desktop() {
      return mq.matches;
    }

    t.addEventListener('pointerenter', function () {
      if (desktop()) openMega();
    });
    t.addEventListener('focus', function () {
      if (desktop()) openMega();
    });
    t.addEventListener('click', function (e) {
      if (!desktop()) return;
      // first click/tap on touch opens, second follows the link
      if (!h.hasAttribute('data-nv-mega-open') && e.pointerType === 'touch') {
        e.preventDefault();
        openMega();
      }
    });
    t.addEventListener('pointerleave', function () {
      if (desktop()) scheduleClose();
    });

    p.addEventListener('pointerenter', function () {
      clearTimeout(closeTimer);
    });
    p.addEventListener('pointerleave', function () {
      scheduleClose();
    });

    // keep open while hovering the header row (between trigger and panel)
    h.addEventListener('pointerleave', function () {
      if (h.hasAttribute('data-nv-mega-open')) scheduleClose();
    });
    h.addEventListener('pointerenter', function () {
      if (h.hasAttribute('data-nv-mega-open')) clearTimeout(closeTimer);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && h.hasAttribute('data-nv-mega-open')) {
        closeMega(true);
        t.focus();
      }
    });

    document.addEventListener('click', function (e) {
      if (!h.hasAttribute('data-nv-mega-open')) return;
      if (p.contains(e.target) || t.contains(e.target)) return;
      closeMega(true);
    });

    // focus leaving the panel closes it
    p.addEventListener('focusout', function (e) {
      if (!p.contains(e.relatedTarget) && e.relatedTarget !== t) scheduleClose();
    });

    // Other top-level links hovered → close
    var others = h.querySelectorAll('.menu-list__link:not([data-nv-mega-trigger])');
    for (var i = 0; i < others.length; i++) {
      others[i].addEventListener('pointerenter', function () {
        if (h.hasAttribute('data-nv-mega-open')) closeMega(false);
      });
    }

    document.addEventListener('scroll', function () {
      if (h.hasAttribute('data-nv-mega-open') && scrollTop() > GLASS_AT + 40) closeMega(false);
    }, { passive: true, capture: true });
  }

  function boot() {
    var h = header();
    if (!h) return;
    // variant: "light" = transparent over light (PDP), used for ink/pill colors
    if (!h.hasAttribute('data-nv-variant')) {
      var tpl = document.body.getAttribute('data-nv-template') || '';
      h.setAttribute('data-nv-variant', tpl === 'product' ? 'light' : 'photo');
    }
    updateGlass();
    wireMega();
  }

  var raf = null;
  function onScroll() {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = null;
      updateGlass();
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  // capture phase catches scrolls on .page-wrapper (or any inner scroller)
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });

  window.addEventListener('resize', updateGlass);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function () {
    boot();
  });
})();
